<template>
  <common-modal-section class="limited-video-alert-modal-section" @close="emitClose">
    <template v-slot:default>
      <modal-title-parts :title="$tc('HomePage.LimitedVideoAlertModal.title')" />
      <modal-message-parts :message="$tc('HomePage.LimitedVideoAlertModal.message')" />
    </template>

    <template v-slot:buttons>
      <atom-icon-link-button
        :linkText="$tc('HomePage.LimitedVideoAlertModal.submitText')"
        :url="link"
        :imgPath="require('@/assets/img/icon/icon_external_link_outline__green.svg')"
      />
      <atom-input-button
        :linkText="$tc('common.close')"
        colorType="tertiary"
        :isDisabled="false"
        @push="emitClose()"
      />
    </template>
  </common-modal-section>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import CommonModalSection from '@/components/common/modal/CommonModalSection.vue'
import ModalTitleParts from '@/components/common/modal/parts/ModalTitleParts.vue'
import ModalMessageParts from '@/components/common/modal/parts/ModalMessageParts.vue'
import AtomIconLinkButton from '@/components/atoms/AtomIconLinkButton.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'

/**
 * HOME 会員限定動画モーダル
 */
export default defineComponent({
  name: 'LimitedVideoAlertModalSection',
  components: {
    CommonModalSection,
    ModalTitleParts,
    ModalMessageParts,
    AtomIconLinkButton,
    AtomInputButton,
  },
  props: {
    link: {
      type: String,
      default: '',
    },
  },
  methods: {
    emitClose(): void {
      /**
       * closeModal
       * 親コンポーネントへ閉じる処理を通知
       */
      this.$emit('close')
    },
  },
})
</script>

<style lang="scss">
.limited-video-alert-modal-section {
  .atom-icon-link-btn {
    img {
      width: 16px;
    }
  }
}
</style>
